/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import { showModal } from "actions";
// import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import "components/widgets/training/Training.css";
import { Trans } from "react-i18next";
import i18n from "i18next";

class PotentialTraining extends Component {
  state = {
    showingChildren: false,
  };

  componentDidMount() {
    // console.log(this.props.t);
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.state);
  }

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 3:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-tv ">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      case 1:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-live-tv"></span>
          </td>
        );
      default:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-class "></span>
          </td>
        );
    }
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Çalışan">10070</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.employee.name}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Rol">10407</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.role ? t.role.name : "Hayır"}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="4">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Departman">potentialtrainings_departman</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.serviceType?.label}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="5">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Önşart Tamamlanma">10409</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {t.preRequisitesCompleted ? i18n.t("10504") : i18n.t("10505")}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="6">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Hedeflenen Pozisyon">10500</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {t.targetedPosition ? i18n.t("10504") : i18n.t("10505")}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Pozisyon Eğitimi">10501</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {t.positionTraining ? i18n.t("10504") : i18n.t("10505")}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="8">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Pozisyon">10502</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.position.name}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="9">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Yeterlilik">10503</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.qualifications}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="10">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Tür">10114</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.formattedMethod}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="11">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Mevcut ETO">10172</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {t.trainingWeight ? t.trainingWeight : "0"}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="12">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Gelecek ETO">10173</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {t.trainingFutureWeight ? t.trainingFutureWeight : "0"}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="13">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup">{t.training.name}</td>
            <td className="showGrup">{t.employee.name}</td>
            <td className="showGrup">{t.role ? i18n.t("10504") : i18n.t("10505")}</td>
            <td className="showGrup">{t.serviceType?.label}</td>
            <td className="showGrup">
              {t.preRequisitesCompleted ? i18n.t("10504") : i18n.t("10505")}
            </td>
            <td className="showGrup">
              {t.targetedPosition ? i18n.t("10504") : i18n.t("10505")}
            </td>
            <td className="showGrup">
              {t.positionTraining ? i18n.t("10504") : i18n.t("10505")}
            </td>
            <td className="showGrup">{t.position.name}</td>
            <td className="showGrup">{t.qualifications}</td>
            <td className="showGrup">{t.formattedMethod}</td>
            <td className="showGrup">
              {t.trainingWeight ? t.trainingWeight : "0"}
            </td>
            <td className="showGrup">
              {t.trainingFutureWeight ? t.trainingFutureWeight : "0"}
            </td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={this.ToggleChildren}>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup">{t.training.name}</td>
          </tr>
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal })(PotentialTraining);
